<template>
	<div>
		<div class="container">
			<Menu :openKey="'6'" :name="'企业文化'"></Menu>
			<div class="content">
				<a-breadcrumb class="nav" :routes="routes">
					<template slot="itemRender" slot-scope="{ route, routes }">
						<span class="active" v-if="routes.indexOf(route) === routes.length - 1">
							{{ route.breadcrumbName }}
						</span>
						<router-link v-else :to="`${basePath}/${route.path}`">
							{{ route.breadcrumbName }}
						</router-link>
					</template>
				</a-breadcrumb>
				<router-view style="margin-top: 20px" v-if="!isRouter"></router-view>
				<div v-if="isRouter">
					<div style="margin-top: 20px">
						<Article v-for="item in data.records" :key="item.articleId" :data="item" @success="success(item)" :name="'企业文化'"></Article>
					</div>
					<a-row>
						<a-col span="12" offset="6" style="text-align: center; padding: 20px 0">
							<a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext" @showSizeChange="setLimit" :current="data.current" />
						</a-col>
					</a-row>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Menu from '../components/menu.vue';
import Article from '../components/article.vue';

import utils from '@/common/utils';
export default {
	components: { Menu, Article },
	data() {
		return {
			data: {},
			isRouter: true,
			param: {
				current: 1,
				limit: 10,
				keyword: ''
			},
			basePath: '/index',
			routes: [
				{
					path: 'home',
					breadcrumbName: '首页'
				},
				{
					path: 'culture',
					breadcrumbName: '企业文化'
				}
			]
		};
	},
	created() {
		this.$watch('$route', (to, from) => {
			// this.isRouter = true;
			// console.log(to);
			if (to.path) {
				this.isRouter = true;
				if (to.path == '/index/culture') {
					this.routes.pop();
				}
			}
		});
	},
	mounted() {
		this.getList();
	},
	methods: {
		getList() {
			utils.showSpin();
			this.http.get('/api/common/culture', this.param).then(ret => {
				this.data = ret.data;
				utils.closeSpin();
			});
		},
		//设置每页的显示条数
		setLimit(current, limit) {
			this.param.page = 1;
			this.param.limit = limit;
			this.getList();
		},
		//页码切换
		getNext(page) {
			this.param.page = page;
			this.getList();
		},
		async success(item) {
			await this.$router.push({
				path: '/index/culture/detail',
				query: {
					id: item.articleId
				}
			});
			this.isRouter = false;
			this.routes.push({
				path: 'culture/detail',
				breadcrumbName: item.title
			});
		}
	}
};
</script>
<style scoped>
.container {
	width: 80%;
	min-width: 598px;
	margin: 0 auto;
	margin-top: 40px;
	display: flex;
}

.content {
	flex: 1;
	margin-left: 80px;
	height: 40px;
	background: #f7f7f7;
}
.nav {
	margin-top: 10px;
	margin-left: 10px;
}
.active {
	color: #e96432 !important;
}
.ant-breadcrumb a:hover {
	color: #e96432 !important;
}
.nav .ant-breadcrumb-link {
	color: #e96432;
}
.ant-breadcrumb {
	color: #e96432;
}
</style>
